import PropTypes from 'prop-types';
import styles from './StreamField.module.scss';
import classNames from 'classnames';
import { snakeToPascal } from '../../utils/caseconverters';

import NewsCardList from '../NewsCardList';
import Accordion from '../Accordion';
import ThreeColumnModule from '../ThreeColumnModule';
import YouTubeVideoList from '../YouTubeVideoList';
import ArtistCarousel from '../ArtistCarousel';
import DownloadLinkList from '../DownloadLinkList';
import ProductImageCardList from '../ProductImageCardList';
import ProductCardList from '../ProductCardList';
import ProductHighlightItem from '../ProductHighlightItem';
import ImageVideoCarousel from '../ImageVideoCarousel';
import SoftwareCardList from '../SoftwareCardList';
import PlayableAudioCardList from '../PlayableAudioCardList';
import AudioPlayerList from '../AudioPlayerList';
import TeaserBlock from '../TeaserBlock';
import ReleaseImageCardList from '../ReleaseImageCardList';
import Banner from '../Banner';
import ArtistNameList from '../ArtistNameList';
import RichText from '../RichText';
import ProductLogoImage from '../ProductLogoImage';
import YouTubeVideo from '../YouTubeVideo/YouTubeVideo';
import EmbedIframe from '../EmbedIframe';
import Alert from '../Alert';
import Stepper from '../Stepper';
import TableModule from '../TableModule';
import TwoColumnModule from '../TwoColumnModule';
import ImageVideo from '../ImageVideo';


const Components = {
    NewsCardList,
    Accordion,
    YouTubeVideoList,
    ArtistCarousel,
    DownloadLinkList,
    ProductImageCardList,
    ThreeColumnModule,
    ProductCardList,
    ProductHighlightItem,
    ImageVideoCarousel,
    SoftwareCardList,
    PlayableAudioCardList,
    AudioPlayerList,
    TeaserBlock,
    ReleaseImageCardList,
    Banner,
    ArtistNameList,
    RichText,
    ProductLogoImage,
    YouTubeVideo,
    EmbedIframe,
    Alert,
    Stepper,
    TableModule,
    TwoColumnModule,
    ImageVideo,
};

const StreamField = ({ items = [], onLinkClick, modifiers = [] }) => {
    if (!items.length) {
        return null;
    }

    const dynamicComponents = items.map((item, index) => {
        if (item.component) {
            item.component = snakeToPascal(item.component);
        } else if (item.wysiwyg) {
            item.component = 'Wysiwyg';
        }

        const Component = Components[item.component];
        if (!Component) {
            return null;
        }

        const extraProps = {};

        if (modifiers.length) {
            extraProps.modifiers = modifiers;
        }

        if (item.component === 'Accordion') {
            extraProps.onLinkClick = onLinkClick;

            // Rendered here rather than in Accordion, which StreamField imports.
            if (item.content) {
                extraProps.children = (
                    <StreamField items={item.content} modifiers={modifiers} />
                );
            }
        }

        return (
            <div
                key={index}
                id={item.id}
                className={classNames(
                    styles['StreamField__Component'],
                    styles[`StreamField__Component--${item.component}`],
                    modifiers.map(
                        (modifier) =>
                            styles[`StreamField__Component--${modifier}`]
                    )
                )}
            >
                <Component {...item} {...extraProps} />
            </div>
        );
    });

    return <div className="StreamField">{dynamicComponents}</div>;
};

StreamField.propTypes = {
    items: PropTypes.array,
    onLinkClicked: PropTypes.func,
    modifiers: PropTypes.array,
};

export default StreamField;
